export default {
  data() {
    return {
      dynamicValidators: {},
    };
  },
  methods: {
    handleXTextInputBlur(fieldName, valuePath = '') {
      const fieldPathValidator = this.getPath(fieldName, valuePath);

      if (fieldPathValidator) {
        fieldPathValidator.$touch();
        this.$set(this.dynamicValidators, fieldName, fieldPathValidator);
      }
    },
    getPath(fieldName, valuePath) {
      if (valuePath) {
        if (Array.isArray(valuePath)) {
          const firstPiece = valuePath.splice(0, 1)[0];

          return valuePath.reduce((path, pathPiece) => path?.[pathPiece], this.$v[firstPiece])[
            fieldName
          ];
        }

        return this.$v[valuePath]?.[fieldName];
      }

      return this.$v[fieldName];
    },
  },
};
